import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal"]
    static values = { autoOpen: Boolean }

    connect() {
        if (this.hasAutoOpenValue && this.autoOpenValue) {
            this.open()
        }
    }

    open(){
        this.modalTarget.classList.remove("hidden")
        document.body.style.overflow = 'hidden'
        
        const footer = document.getElementById('site-footer')
        if (footer) {
            footer.classList.add('hidden')
        }
    }

    close(){
        document.body.style.overflow = 'auto'

        const footer = document.getElementById('site-footer')
        if (footer) {
            footer.classList.remove('hidden')
        }

        const frame = this.element.closest("turbo-frame")
        if (frame) {
            frame.src = ""
            frame.innerHTML = ""
        }else{
            this.modalTarget.classList.add("hidden")
        }
    }
}
